import RulerIcon from '@ubnt/icons/RulerIcon';
import { DistanceUnitsEnum } from '@ubnt/link-core/enums';
import RadioList from '@ubnt/ui-components/Radio/RadioList';
import { ChangeEventHandler, memo, useCallback, useMemo } from 'react';

import { isEnumValue } from '@ubnt/wifi-calculator/utils/isEnumValue';

import SettingsTile from './SettingsTile';

interface UnitTileProps {
  unit: ValuesOf<typeof DistanceUnitsEnum>;
  onUnitChange: (unit: ValuesOf<typeof DistanceUnitsEnum>) => void;
}

const UnitTileImpl = (props: UnitTileProps) => {
  const { unit, onUnitChange } = props;

  const onChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (event) => {
      const value = event.target.id;
      if (isEnumValue(DistanceUnitsEnum, value)) {
        onUnitChange(value);
      }
    },
    [onUnitChange]
  );

  const items = useMemo(
    () => [
      {
        checked: unit === DistanceUnitsEnum.Metric,
        children: 'Metric',
        id: DistanceUnitsEnum.Metric,
        onChange,
      },
      {
        checked: unit === DistanceUnitsEnum.Imperial,
        children: 'Imperial',
        id: DistanceUnitsEnum.Imperial,
        onChange,
      },
    ],
    [unit, onChange]
  );

  return (
    <SettingsTile icon={RulerIcon} title="Unit System">
      <RadioList direction="row" items={items} />
    </SettingsTile>
  );
};

const UnitTile = memo(UnitTileImpl);

export default UnitTile;
